import Button from "@/components/Button";
import styles from "./ReviewClientTasksEmptyState.module.scss";
import type { ReviewClientTasksSimplifyAndLanguage } from "./useReviewClientTasksSimplifyAndLanguage";

type ReviewClientTasksEmptyStateProps = {
  simplifyAndLanguage: ReviewClientTasksSimplifyAndLanguage;
};

export default function ReviewClientTasksEmptyState(
  props: ReviewClientTasksEmptyStateProps,
) {
  return (
    <div
      className={styles.emptyTasksState}
      data-testid="review-client-tasks-empty-state"
    >
      {props.simplifyAndLanguage.isVerbatimCreateAllStatusVisible ? (
        <div
          className={styles.emptyTasksTitle}
          data-testid="review-client-tasks-verbatim-creating"
        >
          Creating your client tasks…
        </div>
      ) : null}
      {props.simplifyAndLanguage.isNoTasksCreatedYetMessageVisible ? (
        <div className={styles.emptyTasksTitle}>
          No tasks have been created yet.
        </div>
      ) : null}
      <div className={styles.emptyTasksBulkActions}>
        <Button
          data-testid="create-simplified-tasks-all-button"
          variant="default"
          size="lg"
          type="button"
          loading={
            props.simplifyAndLanguage.isBulkSimplifyJobBusy &&
            props.simplifyAndLanguage.bulkSimplifyLoadingSource ===
              "emptySimplified"
          }
          disabled={props.simplifyAndLanguage.isSimplifyAllBulkActionsDisabled}
          onClick={() => {
            props.simplifyAndLanguage.runCreateCommunicationThenBulkSimplify(
              "emptySimplified",
            );
          }}
        >
          Create Simplified Tasks for all items
        </Button>
        <Button
          data-testid="create-tasks-all-button"
          variant="outline"
          size="lg"
          type="button"
          loading={
            (props.simplifyAndLanguage.isBulkSimplifyJobBusy &&
              props.simplifyAndLanguage.bulkSimplifyLoadingSource ===
                "emptyVerbatim") ||
            props.simplifyAndLanguage.isVerbatimAllAwaitingTasksOnScreen
          }
          disabled={props.simplifyAndLanguage.isSimplifyAllBulkActionsDisabled}
          onClick={() => {
            props.simplifyAndLanguage.runCreateCommunicationThenVerbatimAll();
          }}
        >
          Create Tasks for all items
        </Button>
      </div>
    </div>
  );
}
